import { useState, useEffect } from "react"
import { Bell } from "lucide-react"
import "./NewsTicker.css"
 
export function NewsTicker() {
  const [tickerItems, setTickerItems] = useState([])
  const [loading, setLoading] = useState(true)
 
  useEffect(() => {
    const fetchTickerData = async () => {
      try {
        const response = await fetch(
          "/wp-json/custom/v1/news-ticker"
        )
        const data = await response.json()
 
        console.log("API DATA 👉", data)
 
        if (Array.isArray(data) && data.length > 0) {
          // ✅ data is already plain text
          const formatted = data.map((text) => {
            const doc = new DOMParser().parseFromString(text, "text/html")
            return doc.body.textContent || ""
          })
 
          setTickerItems(formatted)
        } else {
          setTickerItems([])
        }
      } catch (error) {
        console.error("Error fetching ticker:", error)
        setTickerItems([])
      } finally {
        setLoading(false)
      }
    }
 
    fetchTickerData()
  }, [])
 
  if (loading || tickerItems.length === 0) return null
 
  return (
    <div className="news-ticker-container">
      <div className="news-ticker-label">
        <Bell className="w-4 h-4 text-white mr-2" />
        What's New
      </div>
 
      <div className="news-ticker-wrapper">
        <div className="news-ticker-content">
          {[0, 1].map((loop) => (
            <div key={loop} className="flex items-center shrink-0">
              {tickerItems.map((text, index) => (
                <span key={index} className="news-ticker-item">
                  {text}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}